import { render, staticRenderFns } from "./EditRecipientWhatsAppItem.vue?vue&type=template&id=f2c022d4"
import script from "./EditRecipientWhatsAppItem.vue?vue&type=script&lang=js"
export * from "./EditRecipientWhatsAppItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports